<template>
  <div>
    <template
      v-for="(contact, contactIndex) in contacts"
      :key="contactIndex"
    >
      <BaseSeparator v-if="contactIndex" />
      <OutreachContact
        :contact="contact"
        hide-extras
        hide-preview
        :is-checked="selectedIds.includes(contact.documentId)"
        @checkbox-clicked="emit('contact', contact.documentId)"
        @click="contactClicked"
      />
    </template>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from "vue-router";

import BaseSeparator from "shared/components/base/BaseSeparator.vue";
import OutreachContact from "shared/components/Outreach/OutreachContact/OutreachContact.vue";
import { safePush } from "shared/helpers/routing";
import { singularize } from "shared/helpers/string";
import { type Contact } from "shared/resources";

interface AISuggestedContactsListProps {
  contacts: Contact[];
  selectedIds: string[];
}

defineProps<AISuggestedContactsListProps>();

const emit = defineEmits<{ contact: [string] }>();

const router = useRouter();
const safeRouterPush = safePush({ router });

function contactClicked(contact: Contact, type: string) {
  safeRouterPush({
    name: `outreach-search-${singularize(type)}`,
    params: {
      id: contact.id,
    },
  });
}
</script>
